import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Button from 'shared/button';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderArrowUp } from '@fortawesome/pro-solid-svg-icons';

import './signed_ca.scss';

const NEW_UPLOAD_SIGNED_CA_MESSAGE = 'Drag & Drop CA here';

export function CaDropzone({ existingFileName, isDisabled, onFileSelected }) {
  const [file, setFile] = useState(null);

  const handleDrop = (files) => {
    const file = files[0];
    onFileSelected(file);
    // TODO: `file` should probably be a prop, but check all usages
    // Issue: When rendered inside `SignedCA`, React warns: "Can't perform a React state update on an unmounted
    // component", likely because `onFileSelected` unmounts CaDropzone to show the upload spinner.
    setFile(file);
  };

  const defaultMessage = NEW_UPLOAD_SIGNED_CA_MESSAGE;

  const message = (file && file.name) || existingFileName || defaultMessage;

  const oldContent = (
    <React.Fragment>
      <i className={'fa fa-upload mr-2'}></i>
      <span name="dz-title">{message}</span>
    </React.Fragment>
  );

  const newContent = (
    <React.Fragment>
      <div><FontAwesomeIcon className="ca-upload-icon space-below" icon={faFolderArrowUp} size="lg"/></div>
      <div><p name="dz-title"><strong>{message}</strong></p></div>
      <div><p className="space-below">or</p></div>
      <Button.Accent outlined>Browse Files</Button.Accent>
    </React.Fragment>
  );

  return (
    <Dropzone
      accept={'.pdf'}
      multiple={false}
      name={'ca-uploader'}
      onDrop={handleDrop}
    >
      {({ getRootProps, getInputProps }) => (
        <React.Fragment>
          <div
            className={'ca-uploader-box'}
            style={{ cursor: isDisabled() ? 'not-allowed' : 'pointer' }}
            {...getRootProps()}
          >
            <h4 className={'text-center'}>
              {newContent}
            </h4>
          </div>

          <input {...getInputProps()} />
        </React.Fragment>
      )}
    </Dropzone>
  );
}

CaDropzone.propTypes = {
  existingFileName: PropTypes.string,
  isDisabled: PropTypes.func,
  onFileSelected: PropTypes.func.isRequired
};

export default connect(null)(CaDropzone);
